module.exports = __webpack_public_path__ + "static/media/model1.68af1f4e.png";